(function(){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function addItems(items,btn,after){
    var label=btn?btn.innerHTML:'';
    if(btn){btn.disabled=true;btn.innerHTML='Adding…';}
    var drawer=document.querySelector('cart-drawer');
    var body={items:items};
    if(drawer&&!after){body.sections='cart-drawer,cart-icon-bubble';body.sections_url=window.location.pathname;}
    return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
      .then(function(res){
        if(after){window.location.href=after;return;}
        if(drawer&&res.sections){drawer.renderContents({id:items[0].id,sections:res.sections});}
        else{window.location.href=root+'cart';return;}
        if(btn){btn.innerHTML='Added ✓';setTimeout(function(){btn.innerHTML=label;btn.disabled=false;},1800);}
      })
      .catch(function(err){
        if(btn){btn.innerHTML=(err&&err.description)?'Sorry — '+err.description:'Try again';setTimeout(function(){btn.innerHTML=label;btn.disabled=false;},2600);}
      });
  }
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(f.matches('[data-ins-quick-add]')){
      e.preventDefault();
      var id=(f.querySelector('input[name="id"]:checked')||f.querySelector('[name="id"]')).value;
      addItems([{id:Number(id),quantity:1}],f.querySelector('button[type="submit"]'));
    }
    if(f.matches('[data-ins-multi]')){
      e.preventDefault();
      addItems(JSON.parse(f.getAttribute('data-items')),f.querySelector('button[type="submit"]'),f.getAttribute('data-after'));
    }
    if(f.matches('[data-ins-bundle]')){
      e.preventDefault();
      var a=Number(f.querySelector('[name="jar1"]').value),b=Number(f.querySelector('[name="jar2"]').value);
      var items=a===b?[{id:a,quantity:2}]:[{id:a,quantity:1},{id:b,quantity:1}];
      addItems(items,f.querySelector('button[type="submit"]'),f.getAttribute('data-after'));
    }
  });
  // countdowns
  function tick(){
    document.querySelectorAll('[data-ins-countdown]').forEach(function(el){
      var end=new Date(el.getAttribute('data-ins-countdown')).getTime(),d=end-Date.now();
      var sec=el.closest('.ins-bundle');
      if(isNaN(end))return;
      if(d<=0){if(sec)sec.classList.add('is-ended');return;}
      var s=Math.floor(d/1000);
      var map={d:Math.floor(s/86400),h:Math.floor(s%86400/3600),m:Math.floor(s%3600/60),s:s%60};
      Object.keys(map).forEach(function(k){var n=el.querySelector('[data-'+k+']');if(n)n.textContent=String(map[k]).padStart(2,'0');});
    });
  }
  tick();setInterval(tick,1000);
  document.querySelectorAll('[data-ins-hide-after]').forEach(function(el){var t=new Date(el.getAttribute('data-ins-hide-after')).getTime();if(!isNaN(t)&&Date.now()>t)el.classList.add('is-hidden');});
  // sticky ATC on product page
  var sticky=document.querySelector('[data-ins-sticky-atc]');
  if(sticky){
    var main=document.querySelector('product-form .product-form__submit');
    if(main&&'IntersectionObserver'in window){
      new IntersectionObserver(function(en){sticky.classList.toggle('is-visible',!en[0].isIntersecting&&en[0].boundingClientRect.top<0);}).observe(main);
    }
    if(typeof subscribe==='function'&&window.PUB_SUB_EVENTS){
      subscribe(PUB_SUB_EVENTS.variantChange,function(ev){
        var v=ev&&ev.data&&ev.data.variant,pe=sticky.querySelector('[data-price]');
        if(v&&pe&&window.Shopify&&Shopify.formatMoney){pe.textContent=Shopify.formatMoney(v.price);}
        else if(v&&pe){pe.textContent='$'+(v.price/100).toFixed(2);}
      });
    }
    sticky.querySelector('button').addEventListener('click',function(){
      if(main){if(main.disabled){main.scrollIntoView({behavior:'smooth',block:'center'});}else{main.click();}}
    });
  }
})();
